<div fxLayout="column" fxLayoutGap="10px" >
  <h2 id="title" class="page-header" fxFill>Remitos de venta directa pendientes de impresión</h2>
    <form fxLayout="column" style="margin: 2.5rem" [formGroup]="onholdReleaseVehRemForm" #formDirective="ngForm" autocomplete="off">
      <div id="buttons" fxLayout="column">
        <div style="text-align:right;">
          <rem-file-upload [showSuccessResponseNotifications]="false" (fileUploadSuccessEvent)="showError($event)" endpoint="onhold" fxFlex="100%"></rem-file-upload>
          <button mat-icon-button class="view-remito-buttons" (click)="search()"><mat-icon>pageview</mat-icon></button>
          <button mat-icon-button class="view-remito-buttons" (click)="print()" [disabled]="isLoading">
            <mat-icon *ngIf="!isLoading">description</mat-icon>
            <mat-spinner *ngIf="isLoading" class="loading-spinner-small" diameter="15"></mat-spinner>
          </button>
        </div>
      </div>
      <mat-divider class="mat-divider-header"></mat-divider>
      <div id="searchFieldsRow1" fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="1rem">

        <mat-form-field fxFlex.gt-sm="37%" fxFlex.sm="37%" fxFlex.lt-sm="100%" appearance="outline">
          <mat-label>VIN Letras</mat-label>
          <input matInput #vinLetrasInput [formControl]="vinLetrasControl"
                 placeholder="Vin Letras" maxlength="11">
          <mat-hint align="end">{{vinLetrasInput.value.length || 0}}/11</mat-hint>
        </mat-form-field>
        <mat-form-field fxFlex.gt-sm="37%" fxFlex.sm="37%" fxFlex.lt-sm="100%" appearance="outline">
          <mat-label>VIN Numeros</mat-label>
          <input matInput #vinNumerosInput [formControl]="vinNumerosControl"
                 placeholder="Vin Numeros" minlength="6" maxlength="6">
          <mat-hint align="end">{{vinNumerosInput.value.length || 0}}/6</mat-hint>
        </mat-form-field>

        <mat-form-field fxFlex.gt-sm="1 1 20%" fxFlex.sm="1 1 20%" fxFlex.lt-sm="100%" appearance="outline">
          <mat-label>Fec Gen</mat-label>
          <input matInput [matDatepicker]="fecGen" [formControl]="fecGenControl">
          <mat-hint>DD/MM/YYYY</mat-hint>
          <mat-datepicker-toggle matSuffix [for]="fecGen"></mat-datepicker-toggle>
          <mat-datepicker #fecGen></mat-datepicker>
        </mat-form-field>
      </div>
      <div id="searchFieldsRow2" fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="1rem">

        <mat-form-field fxFlex.gt-sm="48%" fxFlex.sm="48%" fxFlex.lt-sm="100%" appearance="standard">
          <mat-label>Charge To</mat-label>
          <input type="text" matInput [formControl]="chargeToControl" [matAutocomplete]="autoChargeTo">
          <mat-autocomplete #autoChargeTo="matAutocomplete">
            <mat-option *ngFor="let chargeTo of filteredChargeTo | async"
                        [value]="chargeTo.id + ' - ' + chargeTo.desc">
              {{ chargeTo.id }} - {{ chargeTo.desc }}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>

        <mat-form-field fxFlex.gt-sm="48%" fxFlex.sm="48%" fxFlex.lt-sm="100%" appearance="standard">
          <mat-label>Ship To</mat-label>
          <input type="text" matInput [formControl]="destinatarioControl" [matAutocomplete]="autoDestinatario">
          <mat-autocomplete #autoDestinatario="matAutocomplete">
            <mat-option *ngFor="let destinatario of filteredDestinatario | async"
                        [value]="destinatario.id + ' - ' + destinatario.desc">
              {{ destinatario.id }} - {{ destinatario.desc }}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </div>
    </form>

  <!-- Table -->
  <div class="table-height" style="flex-direction: column;display: flex;" *ngIf="showOnholdData">
    <table mat-table matSort [dataSource]="dataSource">

      <!-- VIN Letras Column -->
      <ng-container matColumnDef="vinLetras">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> VIN Letras
          <fab-string-filter #tableFilter columnDef="vinLetras" [operators]="operators" (filterChange)="filterChange($event);"></fab-string-filter>
        </th>
        <td mat-cell  class="left" *matCellDef="let element">  {{ element.vinLetras }} </td>
      </ng-container>

      <!-- VIN Numeros Column -->
      <ng-container matColumnDef="vinNumeros">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> VIN Numeros
          <fab-string-filter #tableFilter columnDef="vinNumeros" [operators]="operators" (filterChange)="filterChange($event);"></fab-string-filter>
        </th>
        <td mat-cell  class="center" *matCellDef="let element">  {{ element.vinNumeros }} </td>
      </ng-container>

      <!-- Fec Gen Column -->
      <ng-container matColumnDef="fecGen">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Fec Gen
          <fab-date-filter #tableFilter columnDef="fecGen" [operators]="dateOperators" (filterChange)="filterChange($event);"></fab-date-filter>
        </th>
        <td mat-cell  class="center" *matCellDef="let element"> {{element.fecGen | customDate}} </td>
      </ng-container>

      <!-- Charge To Column -->
      <ng-container matColumnDef="chargeToCode">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Charge To
          <fab-string-filter #tableFilter columnDef="chargeToCode" [operators]="operators" (filterChange)="filterChange($event);"></fab-string-filter>
        </th>
        <td mat-cell  class="center" *matCellDef="let element"> {{element.chargeToCode}} </td>
      </ng-container>

      <!-- Destinatario Cod Column -->
      <ng-container matColumnDef="codDestino">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Ship To
          <fab-string-filter #tableFilter columnDef="codDestino" [operators]="operators" (filterChange)="filterChange($event);"></fab-string-filter>
        </th>
        <td mat-cell  class="center" *matCellDef="let element"> {{element.codDestino}} </td>
      </ng-container>

      <!-- Destinatario Name Column -->
      <ng-container matColumnDef="nombreDestino">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Ship To Nombre
          <fab-string-filter #tableFilter columnDef="nombreDestino" [operators]="operators" (filterChange)="filterChange($event);"></fab-string-filter>
        </th>
        <td mat-cell  class="center" *matCellDef="let element"> {{element.nombreDestino}} </td>
      </ng-container>

      <!-- Invoice Letter Column -->
      <ng-container matColumnDef="invoiceLetter">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Invoice Letter
          <fab-string-filter #tableFilter columnDef="invoiceLetter" [operators]="operators"
                             (filterChange)="filterChange($event);"></fab-string-filter>
        </th>
        <td mat-cell  class="center" *matCellDef="let element"> {{element.invoiceLetter}} </td>
      </ng-container>

      <!-- Invoice Pto Column -->
      <ng-container matColumnDef="invoicePto">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Invoice Pto Emision
          <fab-string-filter #tableFilter columnDef="invoicePto" [operators]="operators"
                             (filterChange)="filterChange($event);"></fab-string-filter>
        </th>
        <td mat-cell  class="center" *matCellDef="let element"> {{element.invoicePto}} </td>
      </ng-container>

      <!-- Invoice Number Column -->
      <ng-container matColumnDef="invoiceNum">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Invoice Number
          <fab-string-filter #tableFilter columnDef="invoiceNum" [operators]="operators"
                             (filterChange)="filterChange($event);"></fab-string-filter>
        </th>
        <td mat-cell  class="center" *matCellDef="let element"> {{element.invoiceNum}} </td>
      </ng-container>

      <!-- Billing Type Column -->
      <ng-container matColumnDef="billingType">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Doc Type
          <fab-string-filter #tableFilter columnDef="billingType" [operators]="operators"
                             (filterChange)="filterChange($event);"></fab-string-filter>
        </th>
        <td mat-cell  class="center" *matCellDef="let element"> {{element.billingType}} </td>
      </ng-container>

      <!-- Release Button Column -->
      <ng-container matColumnDef="releaseButton">
        <th mat-header-cell *matHeaderCellDef scope="col"></th>
        <td mat-cell *matCellDef="let element"  class="left">
          <button mat-icon-button class="view-remito-buttons" (click)="releaseOnhold(element)">
            <mat-icon>task_alt</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
    </div>
    <mat-paginator #paginator
                   [pageSize]="10"
                   [pageSizeOptions]="[10, 15, 20, 25]"
                   [hidden]="!dataSource.data.length">
    </mat-paginator>


</div>
